<template>
  <div class="pub">
    <p class="title">{{ title }}</p>
    <p class="conference">{{ conference }} <span class="award">{{ award }}</span></p>
    <div class="author-list">
      <p :key="index" v-for="(author, index) in authors">
        <span v-if="author.name === 'Jiaming Qiu'" class="self">{{
          author.name
        }}</span>
        <Link
          v-else-if="author.link !== ''"
          class="author"
          :path="author.link"
          :text="author.name"
        />        <span v-else>{{ author.name }}</span>

        <span v-if="index != Object.keys(authors).length - 1">,&nbsp;</span>
      </p>
    </div>
    <div class="author-list">
      <div v-if="paper !== ''">
        <font-awesome-icon class="icon-style" :icon="['fas', 'file-alt']" />
        <Link :path="paper" text="Paper" />
      </div>
      <div v-if="video !== ''">
        <font-awesome-icon class="icon-style" :icon="['fas', 'video']" />
        <Link :path="video" text="Video" />
      </div>
      <div v-if="slides !== ''">
        <font-awesome-icon
          class="icon-style"
          :icon="['fas', 'file-powerpoint']"
        />
        <Link :path="slides" text="Slides" />
      </div>
    </div>
  </div>
</template>

<script>
import Link from "./Link";

export default {
  name: "Publication",
  props: {
    title: String,
    conference: String,
    award: String,
    authors: Array,
    paper: String,
    video: String,
    slides: String,
  },
  components: {
    Link,
  },
};
</script>

<style scoped>
div.pub {
  margin: 0 0 30px;
}
div.author-list {
  display: flex;
}
div.author-list > div {
  margin-right: 40px;
}
p {
  margin-top: 0;
  margin-bottom: 6px;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  color: #212325;
  font-size: 20px;
  line-height: 150%;
}
p.title {
  font-weight: bold;
}
p.conference {
  font-size: 16px;
}
span {
  font-size: 16px;
}
span.self {
  color: #006699;
  font-weight: bold;
}
span.award {
  color: #FF0000;
  font-weight: bold;
}
a {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  color: #66ccff;
  font-size: 20px;
}
a.author {
  font-size: 16px;
}
.icon-style {
  margin-right: 1em;
  color: #212325;
  font-size: 20px;
}
@media (max-width: 1000px) {
  p {
    font-size: 18px;
  }
  a {
    font-size: 18px;
  }
  p.conference {
    font-size: 14px;
  }
  span {
    font-size: 14px;
  }
  a.author {
    font-size: 14px;
  }
}
@media (max-width: 600px) {
  p {
    font-size: 15px;
  }
  a {
    font-size: 15px;
  }
  p.conference {
    font-size: 12px;
  }
  span {
    font-size: 12px;
  }
  a.author {
    font-size: 12px;
  }
}
</style>